import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const { handleOAuthCallback } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref for processed flag to prevent race conditions in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const hash = window.location.hash;
        const sessionId = hash.split('session_id=')[1]?.split('&')[0];

        if (!sessionId) {
          console.error('No session_id found in URL');
          navigate('/login');
          return;
        }

        const user = await handleOAuthCallback(sessionId);
        
        // Navigate to dashboard with user data
        navigate('/', { 
          replace: true,
          state: { user }
        });
      } catch (error) {
        console.error('OAuth callback error:', error);
        navigate('/login');
      }
    };

    processAuth();
  }, [handleOAuthCallback, navigate]);

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-[#FF6B35] mx-auto mb-4" />
        <p className="text-[#004E64] font-medium">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
